import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="custom-footer">
            <Container>
                <Row>
                    <Col lg={4} md={6} className="mb-4">
                        <div className="footer-section">
                            <div className="footer-brand">
                                <img src="/logo-bear.png" alt="BearSoftware" className="footer-logo" />
                                <h5 className="footer-title gradient-text">BearSoftware</h5>
                            </div>
                            <p className="footer-description">
                                Sviluppiamo soluzioni software innovative e su misura per far crescere
                                il tuo business nel mondo digitale.
                            </p>
                            <div className="social-links">
                                <a href="https://linkedin.com/in/carlo-zamponi" className="social-link" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-linkedin"></i>
                                </a>
                            </div>
                        </div>
                    </Col>

                    <Col lg={2} md={6} className="mb-4">
                        <div className="footer-section">
                            <h6 className="footer-subtitle">Servizi</h6>
                            <ul className="footer-links">
                                <li><Link to="/services/development/sviluppo-web-frontend">Web Development</Link></li>
                                <li><Link to="/services/development/mobile-app-development">Mobile Apps</Link></li>
                                <li><Link to="/services/development/ui-ux-design">UI/UX Design</Link></li>
                                <li><Link to="/services/development/e-commerce-solutions">E-commerce</Link></li>
                                <li><Link to="/services/infrastructure/proxmox">Proxmox VE</Link></li>
                                <li><Link to="/services/consulting/consulenza-tecnica">Consulenza</Link></li>
                            </ul>
                        </div>
                    </Col>

                    <Col lg={3} md={6} className="mb-4">
                        <div className="footer-section">
                            <h6 className="footer-subtitle">Link Rapidi</h6>
                            <ul className="footer-links">
                                <li><Link to="/">Home</Link></li>
                                <li><a href="#about">Chi Siamo</a></li>
                                <li><a href="#what-i-do">Cosa Facciamo</a></li>
                                <li><a href="#contact">Contatti</a></li>
                            </ul>
                        </div>
                    </Col>

                    <Col lg={3} md={6} className="mb-4">
                        <div className="footer-section">
                            <h6 className="footer-subtitle">Contatti</h6>
                            <div className="contact-item">
                                <i className="fas fa-envelope"></i>
                                <span>info@bearsoftware.it</span>
                            </div>
                            <div className="contact-item">
                                <i className="fas fa-phone"></i>
                                <span>0245073413</span>
                            </div>
                            <div className="contact-item">
                                <i className="fas fa-map-marker-alt"></i>
                                <span>Via Isonzo 6/B 22078 Turate (CO), Italia</span>
                            </div>
                        </div>
                    </Col>
                </Row>

                <hr className="footer-divider" />

                <Row>
                    <Col lg={6}>
                        <p className="footer-copyright">
                            © {currentYear} BearSoftware di Carlo Zamponi - P.IVA IT03341180135. Tutti i diritti riservati.
                        </p>
                    </Col>
                    <Col lg={6} className="text-lg-end">
                        <div className="footer-legal">
                            <Link to="/privacy-policy">Privacy Policy</Link>
                            <span className="separator">|</span>
                            <Link to="/terms-of-service">Termini di Servizio</Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;